<template>
  <div class="cards-wrap">
    <div class="top-back">
      <span class="back-arrow" @click="$router.back()"></span>
      Ranking
    </div>

    <img class="top-img" src="../images/top.png" alt="">


    <div class="top-f-3">

      <div class="top1">
        <img class="img-queen" src="../images/top1.png" alt="">
        <div class="avt-wrap">
          <img class="avt" src="../images/av.png" alt="">
        </div>
        <div class="top-btm">
          <img class="top-btm-img" src="../images/top-btm.png" alt="">
          <p class="top-phone no1">{{ranking_list[0].phone}}</p>
          <p class="top-money">{{ranking_list[0].amount}}</p>
        </div>
      </div>

      <div class="top2">
        <img class="img-queen" src="../images/top2.png" alt="">
        <div class="avt-wrap">
          <img class="avt" src="../images/av.png" alt="">
        </div>
        <div class="top-btm">
          <p class="top-phone no2">{{ranking_list[1].phone}}</p>
          <p class="top-money">{{ranking_list[1].amount}}</p>
        </div>
      </div>

      <div class="top3">
        <img class="img-queen" src="../images/top3.png" alt="">
        <div class="avt-wrap">
          <img class="avt" src="../images/av.png" alt="">
        </div>
        <div class="top-btm">
          <p class="top-phone">{{ranking_list[2].phone}}</p>
          <p class="top-money">{{ranking_list[2].amount}}</p>
        </div>
      </div>

    </div>


    <div class="ranking-wrap">
      <div class="des">
        <div class="des-item">ranking</div>
        <div class="des-item">account</div>
        <div class="des-item">amount</div>
      </div>

      <div class="des" v-for="(item,index) in ranking_list" v-if="index > 2">
        <div class="des-item" >No.{{ index + 1 }}</div>
        <div class="des-item" >{{ item.phone }}</div>
        <div class="des-item colorg">{{ item.amount }}</div>
      </div>
    </div>

    <!--    <div class="my-rank">-->
    <!--      <div class="des" style="border-bottom: none">-->
    <!--        <div class="des-item">排名</div>-->
    <!--        <div class="des-item">账号</div>-->
    <!--        <div class="des-item">充值数目</div>-->
    <!--      </div>-->
    <!--    </div>-->


  </div>
</template>

<script>
import Vue from 'vue';
import {
  CountDown,
  Checkbox,
  RadioGroup,
  Icon,
  Radio, Dialog
} from 'vant';
import Fetch from '../../utils/fetch'

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon).use(Dialog);
export default {
  name: "ranking",
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      ranking_list: [],
    }
  },
  mounted() {
  },
  created() {
    this.$parent.footer('user', false);
    this.init();
  },
  methods: {
    //获取用户的卡包
    init() {
      Fetch('/user/getTodayRanking').then((r) => {
        console.log(r);
        this.ranking_list = r.info;
      });
    },


  }
}
</script>

<style scoped lang="less">
.colorg{
  color: #F26237!important;
  font-weight: 700;
}
.no1 {
  color: #EBB476 !important;
}

.no2 {
  color: rgb(253, 233, 209) !important;
}

.top-money {
  position: absolute;
  top: 40px;
  left: 50%;
  text-align: center;
  width: 100px;
  margin-left: -50px;

  border: 1px solid #FFFFFF;
  border-radius: 15px;
  font-weight: 700;
  color: #F26237;
  font-size: 0.35rem;
  height: 30px;
  line-height: 30px;
}

.top-phone {
  position: absolute;
  top: 8px;
  left: 0;
  text-align: center;
  width: 100%;
  font-weight: 700;
  color: #ffffff;
  font-size: 0.45rem;
}

.top-btm-img {
  width: 100%;
  position: absolute;
  height: 100%;
  left: 0;
}

.top-btm {
  position: relative;
  width: 100%;
  height: 80px;

}

.avt {
  display: block;
  width: 70px;
  height: 70px;
  margin: 2.5px auto;
}

.avt-wrap {
  width: 80px;
  border-radius: 50%;
  box-sizing: border-box;
  height: 80px;
  border: 2px solid white;
  margin: 0 auto;
}

.img-queen {
  display: block;
  margin: 0 auto;
  width: 50px;
}

.top-f-3 {
  height: 240px;
  width: 99%;
  margin: 15px auto;
  position: relative;
  //border: 1px solid red;
  //overflow: hidden;
}

.top1 {
  position: absolute;
  width: 150px;
  margin-left: -75px;
  //height: auto;
  left: 50%;
}

.top2 {
  position: absolute;
  width: 150px;
  top: 50px;
  //margin-left: -90px;
  //height: auto;
  left: 0;
}

.top3 {
  position: absolute;
  width: 150px;
  top: 50px;
  //margin-left: -90px;
  //height: auto;
  right: 0;
}

.top-img {
  display: block;
  width: 65%;
  margin: 15px auto;
}

.my-rank {
  display: flex;
  width: 100%;
  height: 40px;
  background: #07c160;
  position: fixed;
  bottom: 0;
  left: 0;
}

.des {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  //border-bottom: 1px solid #bebbbb;
}

.des-item {
  flex: 1;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 0.45rem;
  color: black;
}

.ranking-wrap {
  width: 96%;
  //height: 15rem;
  //border: 1px solid red;
  margin: 15px auto;
  padding-bottom: 60px;
  color: white;
  background: white;
  border-radius: 8px;
  box-shadow: 0 23px 17px 0 rgba(0,0,0,0.1) inset;
}

.left91 {
  float: left;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #7e7e7e;
  color: #d0d0d0;
  width: 1rem;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-left: 20%;
  font-size: 0.4rem;
}

.send-wrap {
  margin: 25px 0;
  height: 40px;
  width: 100%;
}

.send-input {
  width: 50%;
  float: left;
  height: 30px;
  border: 1px solid #b4b3b3;
  font-size: 0.4rem;
  border-left: none;
  text-indent: 5px;
}

.send-btn {
  position: absolute;
  right: 20px;
  top: 40px;
  width: 50px;
  height: 30px;
  background: #3d96ff;
  text-align: center;
  color: white;
  line-height: 30px;
  border-radius: 5px;
}

.use-btn {
  position: absolute;
  right: 20px;
  bottom: 10px;
  width: 50px;
  height: 30px;
  background: #f30619;
  text-align: center;
  color: white;
  line-height: 30px;
  border-radius: 5px;
}

.card-name {
  height: 30px;
  line-height: 30px;
  text-indent: 10px;
  color: white;
}

.card-order {
  height: 30px;
  line-height: 30px;
  text-indent: 10px;
  border-bottom: 1px solid #e5e5e5;
  color: white;
}

.card-item {
  //height: 170px;
  width: 95%;
  margin: 15px auto;
  background: rgba(28, 24, 27, 0.86);
  border-radius: 8px;
  box-sizing: border-box;
  //padding: 10px;
  position: relative;
}

.tab-active {
  background: #07c160;
  color: white;
}

.tab {
  width: 100%;
  display: flex;
  //background: red;
  height: 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #9a9696;
}

.tab-item {
  flex: 33.33%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  box-sizing: border-box;

}

.tab-item:nth-child(1) {
  border-right: 1px solid #e5e5e5;
}

.tab-item:nth-child(2) {
  border-right: 1px solid #e5e5e5;
}

.top-back {
  height: 50px;
  width: 100%;
  //background: #3d96ff;
  position: relative;
  line-height: 50px;
  color: white;
  text-align: center;
  font-size: 28px;
  text-indent: -20px;
  font-weight: 700;
}

.back-arrow {
  float: left;
  width: 20px;
  height: 20px;
  background: url(../../views/images/item/back.png) no-repeat center center;
  background-size: auto 100%;
  margin: 12px 0 0 8px;
}
</style>